<template>
  <div class="exhibition_tool">
    <v-switch
      @change="beforeChangeStatus(expoData)"
      v-model="exhibitionSwitch"
      inset
      dense
      class="exhibition_witch pd-10"
      :label="`${
        expoData.status === 'published'
          ? $t('COMMON.WORD.PUBLISH')
          : $t('COMMON.WORD.UNPUBLISH')
      }`"
    ></v-switch>
    <v-btn
      title
      class="pd-0 no-shadow"
      :href="'https://hei-dong-chuang-zao.gitbook.io/virsody-guide/'"
      :target="'_blank'"
    >
      <v-icon left size="16">mdi-help-circle-outline</v-icon>

      {{ $t('COMMON.WORD.DOCS') }}
    </v-btn>
    <v-btn title class="pd-0 no-shadow" @click="isShowSharFrame = true">
      <v-icon left size="16">mdi-share</v-icon>
      {{ $t('COMMON.WORD.SHARE') }}
    </v-btn>
    <v-btn
      title
      class="pd-0 no-shadow"
      :href="expoData.previewUrl"
      :target="'_blank'"
      :disabled="refreshStatus"
    >
      <v-icon left size="16">mdi-play-circle-outline</v-icon>
      {{ $t('COMMON.WORD.PREVIEW') }}
    </v-btn>
    <ShareFrame v-model="isShowSharFrame" :expo-data="expoData" />
  </div>
</template>
<script>
import {
  publishExhibition,
  getExhibitionByLang
} from '@/api/panel/exhibitions';
import ShareFrame from '@/components/exhibitions/ShareFrame.vue';
export default {
  components: { ShareFrame },
  emits: ['onToggle'],
  props: {
    expoData: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  data: () => ({
    exhibitionSwitch: false,
    isShowSharFrame: false,
    refreshStatus: false
  }),
  methods: {
    beforeChangeStatus(expo) {
      if (expo.status === 'unpublished') {
        this.$store.dispatch('modal/ACTIVE_MODAL', {
          title: this.$t('SPACE.POPUP.COPYWRITING.CONFIRM_PUBLISH'),
          content:
            this.$t('SPACE.POPUP.COPYWRITING.AFTER_PUBLISHED') +
            '\n' +
            this.$t('SPACE.POPUP.COPYWRITING.ANYONE_CAN_VISIT'),
          action: {
            text: this.$t('COMMON.WORD.PUBLISH'),
            callback: async () => {
              await this.toggleStatus(expo);
              this.$store.dispatch('modal/CLOSE_MODAL');
            }
          },
          cancel: {
            callback: () => {
              this.exhibitionSwitch =
                this.expoData.status === 'published' ? true : false;
            },
            text: this.$t('COMMON.WORD.CANCEL')
          },
          close: {
            callback: () => {
              this.exhibitionSwitch =
                this.expoData.status === 'published' ? true : false;
            }
          }
        });
      } else {
        this.toggleStatus(expo);
      }
    },

    async toggleStatus(expo) {
      let status = '';
      this.refreshStatus = true;
      if (expo.status === 'published') status = 'unpublished';
      if (expo.status === 'unpublished') status = 'published';
      const Expo = await publishExhibition({
        id: expo.id,
        status
      });

      if (!Expo.error) {
        this.$store.dispatch('space/setCurrentPreviewUrl', Expo.previewUrl);
        expo.status = Expo.status;
        this.$toast(
          `${this.$t('COMMON.WORD.EXHIBITION')}${this.$t(
            'COMMON.WORD.ALREADY'
          )} ${
            status === 'published'
              ? this.$t('COMMON.WORD.PUBLISH')
              : this.$t('COMMON.WORD.UNPUBLISH')
          }`
        );
        this.refreshStatus = false;
      } else {
        !!Expo.error.message && this.$toast.error(Expo.error.message);
      }
    }
  },
  watch: {
    expoData() {
      this.exhibitionSwitch =
        this.expoData.status === 'published' ? true : false;
    }
  }
};
</script>
<style lang="scss" scoped>
.exhibition_tool {
  display: flex;
  button,
  a {
    height: auto !important;
    background-color: transparent !important;
    &:before {
      display: none;
    }

    ::v-deep .v-ripple__container {
      display: none;
    }
    .v-btn__content .v-icon--left {
      margin-right: 3px;
    }
  }
  ::v-deep {
    .v-input--switch.v-input--is-dirty .v-input--switch__thumb {
      transform: translate(14px, 0) !important;
    }
    .v-input--selection-controls .v-input__slot {
      margin: 0;
    }
    .v-input--selection-controls.v-input {
      margin: 0;
      padding: 0 16px;
    }
    .v-input__control .v-messages {
      display: none;
    }
    .v-input--selection-controls .v-input__slot > .v-label {
      font-size: 14px;
      color: #fff;
    }

    .v-input--switch--inset.v-input--is-dirty
      .v-input--selection-controls__ripple {
      transform: translate(15px, 0) !important;
    }
    .v-input--switch__thumb {
      width: 16px;
      height: 16px;
      top: calc(50% - 8px);
    }
    .v-input--switch--inset .v-input--selection-controls__input {
      width: 36px;
      height: 20px;
      margin-right: 7px;
    }

    .v-input--switch.v-input--dense.v-input--switch--inset
      .v-input--switch__track {
      top: calc(50% - 9px);
      width: 36px;
      height: 20px;
      left: -2px;
    }
    .v-input--switch .v-input--selection-controls__ripple {
      width: 21px;
      height: 19px;
      left: -9px !important;
      top: calc(50% - 16px);
    }
    .theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
      background-color: inherit !important;
    }
  }
}
</style>